import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=4bbeccbb&scoped=true&"
import script from "./deposit.vue?vue&type=script&lang=js&"
export * from "./deposit.vue?vue&type=script&lang=js&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=4bbeccbb&prod&scoped=true&lang=css&"
import style1 from "./deposit.vue?vue&type=style&index=1&id=4bbeccbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbeccbb",
  null
  
)

export default component.exports